import Vue from 'vue'
import VueRouter from 'vue-router'
import WebRouter from './web'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        redirect: () => {
            return '/web/staff'
        }
    },
    {
        path: '*',
        component: () => import('../components/404'),
        meta: {
            title: '页面找不到了',
            needLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/file/preview',
        component: () =>
            import ('../views/file/preview'),
        meta: {
            title: '文件预览',
            needLogin: false, // 是否需要登录才能访问
            isLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/tiaoz',
        component: () =>
            import ('../views/web/tiaoz'),
        meta: {
            title: '登录',
            isLogin: false // 是否需要登录才能访问
        }
    },

]

const router = new VueRouter({
    routes: [...routes, ...WebRouter],
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach((to, from, next) => {
    // 因为导航守卫会比 created 更早触发，所以要先获取本地数据
    let paths = to.path.split('/')
    if (to.meta.isLogin) {
        window.localStorage.clear()
        next()
    } else {
        let user = JSON.parse(window.localStorage.getItem("user"));
        if ((to.meta.needLogin && user) || !to.meta.needLogin) {
            let index = -1
            if (user)switch (Number(user.mrole || 0)) {
                case 1 ://超管
                    index = paths.indexOf('staff') & paths.indexOf('principal')
                    if (index !== -1) {
                        paths[index] = 'admin'
                    }
                    break
                case 2 ://审核人
                    index = paths.indexOf('staff') &  paths.indexOf('admin')
                    if (index !== -1) {
                        paths[index] = 'principal'
                    }
                    break
                case 3 ://执行人员
                    index = paths.indexOf('principal') &  paths.indexOf('admin')
                    if (index !== -1) {
                        paths[index] = 'staff'
                    }
                    break
            }
            let rePath = paths.join('/')
            if (rePath === to.path) {
                next()
            } else {
                next({
                    path: rePath,
                    params: to.params,
                    query: to.query
                })
            }
        } else {
            next({
                path: `/web/login`,
                params: {...to.params, redirect: decodeURI(window.location.pathname)},
                query: to.query
            })
        }
    }

});

export default router